import { useDocumentDownloadQuery } from '../../../api/user.api';
import { USER_GUIDE_MODAL_TITLE } from '../../../constants/messages';
import DocumentModal from '../DocumentModal/DocumentModal';

type UserGuideModalProps = {
	onClose: () => void;
};

export const UserGuideModal = ({ onClose }: UserGuideModalProps) => {
	const { data, isLoading, isError } = useDocumentDownloadQuery({
		documentDownloadType: 'USER_GUIDE',
	});

	return (
		<DocumentModal
			{...{
				data,
				filename: 'Circadia_User_Guide',
				isError,
				isLoading,
				onClose,
				title: USER_GUIDE_MODAL_TITLE,
			}}
		/>
	);
};
